<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import {
  euroPaylessIssueMethods,
  euroCouponsTutorialMethods,
  euroHabeasDataReportsManagement,
  captacionMethods,
} from '@state/helpers'
import ThirdpartyMultiselect from '@components/euro_coupons/thirdparty/Select'
import CustomDatePickerRange from '@components/CustomDatePickerRange'
import CustomMultiselect from '@/src/components/CustomMultiselect.vue'
import FormSelect from '@/src/components/form/Select.vue'
import SelectMultipleSearch from '@/src/components/form/SelectMultipleSearch.vue'
import downloadModal from '@/src/components/reports/management/modalDownload.vue'
import ActionButton from '@components/buttons/ActionButton.vue'
import ModalDetail from '@/src/components/reports/management/modalDetail.vue'

export default {
  name: 'Reportes',
  page: {
    title: 'Reportes',
    meta: [{ name: 'Reportes', content: getSecret('DESCRIPTION') }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    ThirdpartyMultiselect,
    CustomDatePickerRange,
    CustomMultiselect,
    FormSelect,
    downloadModal,
    ActionButton,
    ModalDetail,
    SelectMultipleSearch,
    EuroCouponsIssueDetail: () => import('@components/reports/management/modalDetailPayless'),
  },
  data() {
    return {
      title: this.$t('Reportes'),
      items: [
        {
          text: this.$t('home'),
          href: '/',
        },
        {
          text: this.$t('Reportes'),
          active: true,
        },
      ],

      reasonsOptions: [
        {label: 'Duplicada.', value: 1},
        {label: 'Mayor Valor.', value: 2},
        {label: 'Menor Valor.', value: 3},
        {label: 'No Coincide.', value: 4},
        {label: 'Redimida Correctamente.', value: 5}
      ],
      loadingReport: false,
      tableHeaders: [],
      toDetail: {},
      showDetail: false,
      filterset: null,
      filters: {
        CO: null,
        reason: null,
        Caja: null,
        casherRegister__in: null,
        x: null,
        date__gte: null,
        date__lte: null,
      },
      cash_query: {
        key: 'store_code',
        value: '',
      },
      showDownload: false,
    }
  },

  mounted() {
    this.setShowTutorial(true)
    this.setTutorialUrl('reporte_payless')

  },

  destroyed() {
    this.setShowTutorial(false)
  },

  beforeMount() {
    this.tableHeaders = [
        { key: 'location', label: this.$t('location') },
        { key: 'date', label: this.$t('date') },
        { key: 'reason', label: this.$t('reason') },
        { key: 'actions', label: this.$t('actions') },
    ]
  },

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = []
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`)
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join('&')
        }
        this.filter()
      },
    },
  },

  methods: {
    ...euroPaylessIssueMethods,
    ...euroCouponsTutorialMethods,
    ...euroHabeasDataReportsManagement,
    ...captacionMethods,
    myProvider(ctx) {
      let context = this
      ctx = context.$table_params(ctx)
      ctx += context.filterset ? `&${context.filterset}` : ''
      const promise = context.fetchEuroPaylessIssue(ctx)
      return promise
        .then((data) => {
          data.results.forEach(e => {
            const option = this.reasonsOptions.find(option => option.value === e.reason);
            if (option) {
              e.reason_description=option.label;
            } else {
              e.reason_description= "Motivo no valido";
            }
          });
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },
    setFilter(filter, value) {
      this.filters[filter] = value
      console.log(value)
      if (filter == 'CO') {
        this.cash_query = {
          key: 'store_code',
          value: this.filters.CO ? this.filters.CO : '',
        }
        this.filters.x = null
        this.filters.casherRegister__in = null
      }
      if (filter == 'x') {
        console.log(this.filters.x)
        let arrayTemp = this.filters.x
        let arrayTemp2 = []
        for (let register of arrayTemp) {
          arrayTemp2.push(register.id)
        }
        console.log(arrayTemp2)
        this.filters.casherRegister__in = arrayTemp2
        if (this.filters.casherRegister__in.length == 1) {
          this.filters.casherRegister__in.push('xxxx')
        }
      }
    },

    filter() {
      this.$refs.table.lastFilter = ''
      this.$refs.table.onFiltered()
      setTimeout(() => this.$refs.table.refresh(), 200)
    },

    clear() {
      this.filters.CO = null
      this.filters.Caja = null
      this.filters.casherRegister__in = null
      this.filters.date__gte = null
      this.filters.date__lte = null
      this.filters.reason = null

      this.filterset = null
      setTimeout(() => this.$refs.table.refresh(), 200)
    },
    getReport() {
      let _ = this
      _.loadingReport = true
      let query = `?date__lte=${this.filters.date__lte}&date__gte=${this.filters.date__gte}`
      const promise = _.fetchReportManagementExcelPayless({
        query: query,
        type: { responseType: 'arraybuffer' },
      })
      return promise
        .then((response) => {
          const data = response.data
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.ms-excel',
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Reporte Payless.xlsx`)
          document.body.appendChild(link)
          link.click()
          _.loadingReport = false
        })
        .catch((error) => {
          _.loadingReport = false
          console.error(error)
          _.$axios_error_noty(
            'Se presento un error en la descarga del archivo.'
          )
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
              <b>{{ $t('filters') }}</b>
            </b-row>
            <b-row>
              <b-col md="3" class="p-0" style="margin: 0 1rem 0 0">
                <b-col>
                  <CustomDatePickerRange
                    :label="'date'"
                    :value_start="filters.date__gte"
                    :value_end="filters.date__lte"
                    @input_start="(value) => setFilter('date__gte', value)"
                    @input_end="(value) => setFilter('date__lte', value)"
                  />
                </b-col>
              </b-col>
              <b-col v-if="filters.date__gte && filters.date__lte" md="3" class="p-0" style="margin: 0 1rem 0 1rem">
                <FormSelect
                  :value="filters.CO"
                  :label="$t('Centro operación')"
                  :fetchOptions="fetchCoOptions"
                  :drfProvider="true"
                  @input="(value) => setFilter('CO', value)"
                  :withOutBorder="true"
                  :search="true"
                />
              </b-col>
              <b-col v-if="filters.date__gte && filters.date__lte" md="3" class="p-0" style="margin: 0 1rem 0 1rem">
                <CustomMultiselect
                  :label="'reason'"
                  :options="reasonsOptions"
                  :value="filters.reason"
                  @input="(value) => {
                    setFilter('reason', value)
                    }"
                ></CustomMultiselect>
              </b-col>
              <b-col v-if="filters.date__gte && filters.date__lte" md="3" class="p-0" style="margin: 0 1rem 0 1rem">
                <SelectMultipleSearch
                  :value="filters.x"
                  :label="$t('Código de Vendedor')"
                  :fetchOptions="fetchCashRegisterOptions"
                  :drfProvider="true"
                  :reqParams="cash_query"
                  :key="filters.CO"
                  :multiple="true"
                  @input="(value) => setFilter('x', value)"
                  :withOutBorder="true"
                  :search="true"
                >
                </SelectMultipleSearch>
              </b-col>

              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="shadow">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              :key="filters.CO && filters.date__gte && filters.date__lte"
              v-if="filters.date__gte && filters.date__lte"
              :filterOption="false"
            >
              <template v-slot:buttons>
                <b-button
                  variant="outline-primary rounded-lg  mx-1"
                  @click="getReport"
                >
                  <b-spinner
                    v-if="loadingReport"
                    small
                    label="Spinning"
                  ></b-spinner>
                  <i v-else class="fas fa-download"></i>
                </b-button>
              </template>

              <template v-slot:cell(location)="row">
                <p class="p-0 m-0"><span class="font-weight-bold">DOC CAJERO:</span> {{row.item.cash_register_document}}</p>
                <p class="p-0 m-0"><i class="fas fa-map-marker-alt"></i> {{row.item.CO}} · {{row.item.cash_register}}</p>

              </template>
              <template v-slot:cell(reason)="row">
                {{row.item.reason_description}}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="()=>{showDetail=true; toDetail=row.item}"
                  >
                    <i
                      class="fe-info fe-2x"
                    ></i>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <EuroCouponsIssueDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {}
        }
      "
    >
    </EuroCouponsIssueDetail>

    <downloadModal
      v-if="showDownload"
      :filters="filters"
      :loadingReport="loadingReport"
    ></downloadModal>
  </Layout>
</template>
